import React, { Suspense, lazy, useEffect, useState, useRef, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext.js";

import config from "../../../config/config.json";

//images
import Logo from "../../../assets/jsxImages/logo";

//styles
import "../../../assets/css/Header.css";

//Services
import { Link, Switch, Route, Redirect } from "react-router-dom";
import { PrivateRouteOfficialNumberEnterprise } from "../../../services/PrivateRouteOfficialNumber";

//Pages for switch router
//Components for user
const LoadingButton = lazy(() => import("../../../components/LoadingButton"));
const MainPage = lazy(() => import("../../MainPage/MainPage.js"));
const Service = lazy(() => import("../../Services/Service.js"))
const Multipagos = lazy(() => import("../../Multipagos/Multipagos.js"));
const PrivateRoute = lazy(() => import("../../../services/PrivateRoute"));
const PrivateRouteEnterprise = lazy(() =>
    import("../../../services/PrivateRouteEnterprise")
);

const DashboardCivic = lazy(() =>
    import("../../Dashboard/Civic/DashboardCivic")
);
const TramitesCivic = lazy(() =>
    import("../../Dashboard/Civic/TramitesCivic.js")
);
const DocumentsCivic = lazy(() =>
    import("../../Dashboard/Civic/DocumentCivic.js")
);
const MainPageValle = lazy(() =>
    import("../../MainPageValle/MainPageValle.js")
);
const ProfileCivic = lazy(() => import("../../Dashboard/Civic/ProfileCivic"));
const ProfileName = lazy(() =>
    import(
        "../../Dashboard/Civic/Content/ProfileContent/ProfileOptions/ProfileName"
    )
);
const ProfileCurp = lazy(() => 
    import(
        "../../Dashboard/Civic/Content/ProfileContent/ProfileOptions/ProfileCurp"
        )
);
const ProfileDate = lazy(() =>
    import(
        "../../Dashboard/Civic/Content/ProfileContent/ProfileOptions/ProfileDate"
    )
);
const ProfileAddress = lazy(() =>
    import(
        "../../Dashboard/Civic/Content/ProfileContent/ProfileOptions/ProfileAddress"
    )
);
const ProfileEmail = lazy(() =>
    import(
        "../../Dashboard/Civic/Content/ProfileContent/ProfileOptions/ProfileEmail"
    )
);
const ProfilePassword = lazy(() =>
    import(
        "../../Dashboard/Civic/Content/ProfileContent/ProfileOptions/ProfilePassword"
    )
);
const ProfileSexo = lazy(() =>
    import(
        "../../Dashboard/Civic/Content/ProfileContent/ProfileOptions/ProfileSexo"
    )
);
const ProfilePhone = lazy(() =>
    import(
        "../../Dashboard/Civic/Content/ProfileContent/ProfileOptions/ProfilePhone"
    )
);

/*Components for enterprise users*/
const DashboardEnterprise = lazy(() =>
    import("../../Dashboard/Enterprise/DashboardEnterprise")
);

const TramiteEnterprise = lazy(() =>
    import("../../Dashboard/Enterprise/TramiteEnterprise")
);

const DocumentEnterprise = lazy(() =>
    import("../../Dashboard/Enterprise/DocumentEnterprise")
);

const ProfileEnterprise = lazy(() =>
    import("../../Dashboard/Enterprise/ProfileEnterprise")
);

const ProfileEnterpriseName = lazy(() =>
    import(
        "../../Dashboard/Enterprise/Content/ProfileEnterpriseOptions/ProfileEnterpriseName"
    )
);

const ProfileEnterpriseOwner = lazy(() =>
    import(
        "../../Dashboard/Enterprise/Content/ProfileEnterpriseOptions/ProfileEnterpriseOwner"
    )
);
const ProfileEnterpriseRFC = lazy(() =>
    import(
        "../../Dashboard/Enterprise/Content/ProfileEnterpriseOptions/ProfileEnterpriseRFC"
    )
);

const ProfileEnterpriseCategory = lazy(() =>
    import(
        "../../Dashboard/Enterprise/Content/ProfileEnterpriseOptions/ProfileEnterpriseCategory"
    )
);

const ProfileEnterpriseAddress = lazy(() =>
    import(
        "../../Dashboard/Enterprise/Content/ProfileEnterpriseOptions/ProfileEnterpriseAddress"
    )
);

const ProfileEnterpriseEmail = lazy(() =>
    import(
        "../../Dashboard/Enterprise/Content/ProfileEnterpriseOptions/ProfileEnterpriseEmail"
    )
);
const ProfileEnterprisePhone = lazy(() =>
    import(
        "../../Dashboard/Enterprise/Content/ProfileEnterpriseOptions/ProfileEnterprisePhone"
    )
);
const ProfileEnterprisePassword = lazy(() =>
    import(
        "../../Dashboard/Enterprise/Content/ProfileEnterpriseOptions/ProfileEnterprisePassword"
    )
);
const EditNumeroOficial = lazy(() =>
    import("../../../forms/Control Urbano/Numero oficial/EditNumeroOficial")
);
const AntiguedadConstruccionEdit = lazy(() =>
    import(
        "../../../forms/Control Urbano/AntiguedadConstruccion/AntiguedadConstruccionEdit"
    )
);

const ProcedureInformation = lazy(() =>
    import("../../ProcedureInformation/ProcedureInformation.js")
);

const PrivateRouteOfficialNumber = lazy(() =>
    import("../../../services/PrivateRouteOfficialNumber")
);

const ProcedureEdit = lazy(() =>
    import("../../../forms/components/ProcedureEdit")
);
const LoginMainPage = lazy(() => import("../../LoginPage/LoginMainPage"));
const RecoveryPassword = lazy(() => import("../../LoginPage/RecoveryPassword"));
const SAREComponent = lazy(() => import("./SAREComponent"));

const Civic = (props) => {

return (
    <Route>
        <DashboardCivic></DashboardCivic>
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL + config.route.DASHBOARD_CIVIC.CIVIC
            }`}
            component={TramitesCivic}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.DOCUMENTS
            }`}
            component={DocumentsCivic}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.PROFILE
            }`}
            component={ProfileCivic}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.PROFILE +
                config.route.DASHBOARD_CIVIC.PROFILE_VIEWS.NAME
            }`}
            component={ProfileName}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.PROFILE +
                config.route.DASHBOARD_CIVIC.PROFILE_VIEWS.CURP
            }`}
            component={ProfileCurp}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.PROFILE +
                config.route.DASHBOARD_CIVIC.PROFILE_VIEWS.DATE
            }`}
            component={ProfileDate}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.PROFILE +
                config.route.DASHBOARD_CIVIC.PROFILE_VIEWS.PASSWORD
            }`}
            component={ProfilePassword}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.PROFILE +
                config.route.DASHBOARD_CIVIC.PROFILE_VIEWS.ADDRESS
            }`}
            component={ProfileAddress}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.PROFILE +
                config.route.DASHBOARD_CIVIC.PROFILE_VIEWS.EMAIL
            }`}
            component={ProfileEmail}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.PROFILE +
                config.route.DASHBOARD_CIVIC.PROFILE_VIEWS.SEXO
            }`}
            component={ProfileSexo}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.PROFILE +
                config.route.DASHBOARD_CIVIC.PROFILE_VIEWS.PHONE
            }`}
            component={ProfilePhone}
        />
        <Route
            exact
            path={
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.NEWTRAMITE_FOLIO
            }
            component={EditNumeroOficial}
        />

        <Route
            exact
            path={
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.EDITTRAMITE +
                config.route.DASHBOARD_CIVIC.FORM_PATHS.ANTIGUEDAD_CONSTRUCCION
            }
            component={AntiguedadConstruccionEdit}
        />

        <Route
            exact
            path={
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.EDITTRAMITE +
                config.route.DASHBOARD_CIVIC.FORM_PATHS.NUMERO_OFICIAL
            }
            component={EditNumeroOficial}
        />
        <Route
            exact
            path={
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_CIVIC.CIVIC +
                config.route.DASHBOARD_CIVIC.EDITTRAMITE +
                config.route.DASHBOARD_CIVIC.FORM_PATHS.GENERAL_EDIT
            }
            component={ProcedureEdit}
        />
    </Route>
)}

const Enterprise = (props) => (
    <Route>
        <DashboardEnterprise></DashboardEnterprise>
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE
            }`}
            component={TramiteEnterprise}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.DOCUMENTS
            }`}
            component={DocumentEnterprise}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE
            }`}
            component={ProfileEnterprise}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE_VIEWS.ENTERPRISE_NAME
            }`}
            component={ProfileEnterpriseName}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE_VIEWS.OWNER
            }`}
            component={ProfileEnterpriseOwner}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE_VIEWS.RFC
            }`}
            component={ProfileEnterpriseRFC}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE_VIEWS.CATEGORY
            }`}
            component={ProfileEnterpriseCategory}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE_VIEWS.ADDRESS
            }`}
            component={ProfileEnterpriseAddress}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE_VIEWS.EMAIL
            }`}
            component={ProfileEnterpriseEmail}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE_VIEWS.PHONE
            }`}
            component={ProfileEnterprisePhone}
        />
        <Route
            exact
            path={`${
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE +
                config.route.DASHBOARD_ENTERPRISE.PROFILE_VIEWS.PASSWORD
            }`}
            component={ProfileEnterprisePassword}
        />
        <PrivateRouteOfficialNumberEnterprise
            exact
            path={
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.EDITTRAMITE +
                config.route.DASHBOARD_ENTERPRISE.FORM_PATHS.NUMERO_OFICIAL
            }
            component={EditNumeroOficial}
            {...props}
        />
        <PrivateRouteOfficialNumberEnterprise
            exac
            path={
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.EDITTRAMITE +
                config.route.DASHBOARD_ENTERPRISE.FORM_PATHS
                    .ANTIGUEDAD_CONSTRUCCION
            }
            component={AntiguedadConstruccionEdit}
            {...props}
        />
        <PrivateRouteOfficialNumberEnterprise
            exac
            path={
                process.env.PUBLIC_URL +
                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE +
                config.route.DASHBOARD_ENTERPRISE.EDITTRAMITE +
                config.route.DASHBOARD_ENTERPRISE.FORM_PATHS.GENERAL_EDIT
            }
            component={ProcedureEdit}
            {...props}
        />
    </Route>
);

export default function HeaderSection(props) {
    const { 
        isAuthenticated, 
        userData,
        handleLogout
    } = useContext(AuthContext);

    const [typeUser, setTypeUser] = useState();
    const btnToMenu = useRef(null);

    useEffect(() => {
        if(isAuthenticated)
            setTypeUser(userData.userType);

    }, [isAuthenticated, userData]);

    return (
        <div data-toggle="collapse" data-target=".navbar-collapse.show">
            {/* this part is the header of page */}
            <nav
                id="changed-color"
                className={`fixed-top navbar navbar-expand-lg navbar-light bg-light barra ${
                    window.location.href === process.env.PUBLIC_URL + "/civic"
                        ? "nav-bg-admin"
                        : ""
                } d-flex justify-content-between d-print-none`}
            >
                {/* Here, you can change the principal image of the header*/}
                <div className="col-3 align-self-start ">
                    <a
                        className="row collapse navbar-collapse"
                        href={`${process.env.PUBLIC_URL}/`}
                    >
                        <Logo/>
                    </a>
                    <a
                        className="row navbar-toggler"
                        href={`${process.env.PUBLIC_URL}/`}
                    >
                        <Logo mobile={true}/>
                    </a>
                </div>
                {/* this part of the button is for navbar responsive, when the screen is small change of collpase button with the same links */}
                <div className="col-7">
                    <div className="d-flex flex-row-reverse">
                        <button
                            ref={btnToMenu}
                            className="navbar-toggler"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    </div>
                    <div
                        className="collapse my-bg-light navbar-collapse justify-content-end text-left py-2"
                        id="navbarSupportedContent"
                    >
                        <div className="navbar-nav poppins-bold move-center">
                            {props.location.pathname === "/~tramites/" ? (
                                <Link
                                    className="btn-link nav-item nav-link active"
                                    rel="noreferrer"
                                    onClick={() => window.location.reload()}
                                    variant="link"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                    to={`${process.env.PUBLIC_URL}/`}
                                >
                                    <p
                                        className="header-color-strong poppins-bold"
                                        style={{ marginBottom: "0rem" }}
                                    >
                                        Trámites
                                    </p>
                                </Link>
                            ) : (
                                <Link
                                    className="btn-link nav-item nav-link"
                                    variant="link"
                                    to={`${process.env.PUBLIC_URL}/`}
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                >
                                    <p
                                        className="header-color-strong"
                                        data-bs-toggle="collapse"
                                        data-bs-target=".navbar-collapse.show"
                                    >
                                        Trámites
                                    </p>
                                </Link>
                            )}
                            <Link
                                className="btn-link nav-link"
                                data-toggle="collapse"
                                data-target=".navbar-collapse.show"
                                to={`${process.env.PUBLIC_URL}/sare`}
                            >
                                <p className="header-color-strong">SARE</p>
                            </Link>
                            <a
                                className="btn-link nav-link"
                                rel="noreferrer"
                                variant="link"
                                href={config.external_route.WEB_ENSENADA}
                                target="_blank"
                            >
                                <p className="header-color-strong ">
                                    Municipio
                                </p>
                            </a>
                            <a
                                className="btn-link nav-link"
                                variant="link"
                                rel="noreferrer"
                                href="http://retys.bajacalifornia.gob.mx/"
                                target="_blank"
                            >
                                <p className="header-color-strong">Estado</p>
                            </a>
                            <a
                                className="btn-link nav-link"
                                variant="link"
                                rel="noreferrer"
                                href={config.external_route.WEB_TRANSPARENCIA}
                                target="_blank"
                            >
                                <p className="header-color-strong">
                                    Transparencia
                                </p>
                            </a>
                        </div>
                        <form
                            className="form-inline push-up add-mb"
                            style={{ justifyContent: "center" }}
                        >
                            {isAuthenticated ? (
                                <div className="dropdown btn-link">
                                    <hr />
                                    <strong
                                        className="header-color-strong dropdown-toggle poppins-bold mb-2 move-right"
                                        type="button"
                                        id="user-dropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        {userData.name}
                                    </strong>
                                    <hr />
                                    <div
                                        className="dropdown-menu dropdown-menu-lg-right poppins-regular"
                                        aria-labelledby="user-dropdown"
                                    >
                                        {(isAuthenticated && typeUser === 4) ? (
                                            <Link
                                                className="dropdown-item "
                                                type="button"
                                                data-toggle="collapse"
                                                data-target=".navbar-collapse.show"
                                                to={`${
                                                    process.env.PUBLIC_URL +
                                                    config.route
                                                        .DASHBOARD_ENTERPRISE
                                                        .ENTERPRISE
                                                }`}
                                            >
                                                Mis trámites
                                            </Link>
                                        ) : (
                                            <Link
                                                className="dropdown-item"
                                                type="button"
                                                data-toggle="collapse"
                                                data-target=".navbar-collapse.show"
                                                to={`${
                                                    process.env.PUBLIC_URL +
                                                    config.route.DASHBOARD_CIVIC
                                                        .CIVIC
                                                }`}
                                            >
                                                Mis trámites
                                            </Link>
                                        )}
                                        <a
                                            href=" "
                                            className="dropdown-item"
                                            type="button"
                                            onClick={handleLogout}
                                        >
                                            Cerrar sesión
                                        </a>
                                    </div>
                                </div>
                            ) : (
                                <Link
                                    className="btn-link my-0 my-sm-0 text-center hidden"
                                    data-toggle="collapse"
                                    data-target=".navbar-collapse.show"
                                    variant="link"
                                    to={{
                                        pathname: `${
                                            process.env.PUBLIC_URL +
                                            config.route.LOGIN
                                        }`,
                                        state: {
                                            pathHistory:
                                                props.location.pathname,
                                        },
                                    }}
                                >
                                    <hr></hr>
                                    <div className="px-2">
                                        <strong className="header-color-strong">
                                            Iniciar sesión
                                        </strong>
                                    </div>
                                    <hr></hr>
                                </Link>
                            )}
                        </form>
                    </div>
                </div>
            </nav>
            <div
                id="main"
                className=""
                style={{ 
                    paddingTop: "100px", 
                    overflowX: "hidden",
                    minHeight: "100vh"
                }}
            >
                <Suspense fallback={<LoadingButton />}>
                    <Switch>
                        <Route
                            exact
                            path={`${process.env.PUBLIC_URL}/sare`}
                            component={SAREComponent}
                        />
                        <Route
                            exact
                            path={`${
                                process.env.PUBLIC_URL + config.route.RECOVERY
                            }`}
                            component={RecoveryPassword}
                        />
                        <PrivateRouteEnterprise
                            path={`${
                                process.env.PUBLIC_URL +
                                config.route.DASHBOARD_ENTERPRISE.ENTERPRISE
                            }`}
                            component={Enterprise}
                        />
                        <PrivateRoute
                            path={`${
                                process.env.PUBLIC_URL +
                                config.route.DASHBOARD_CIVIC.CIVIC
                            }`}
                            component={Civic}
                        />
                        <Route
                            path={`${process.env.PUBLIC_URL}/tramite/:homoclave`}
                            component={ProcedureInformation}
                        />
                        <Route
                            exact
                            path={`${process.env.PUBLIC_URL}/service/:service`}
                            component={Service}
                        />
                        <Route
                            exact
                            path={`${process.env.PUBLIC_URL}/`}
                            component={MainPage}
                        />
                        <Route
                            exact
                            path={`${process.env.PUBLIC_URL}/valle`}
                            component={MainPageValle}
                        />
                        <Route
                            path={`${process.env.PUBLIC_URL}/valle/:searchInfo`}
                            component={MainPageValle}
                        />
                        <Route
                            path={`${process.env.PUBLIC_URL}/:searchInfo`}
                            component={MainPage}
                        />
                    </Switch>
                </Suspense>
            </div>
        </div>
    );
}
